import React from 'react';
import EmptyIcon from '../../../assets/images/notifications/empty-notification.png';

interface EmptyStateProps {
  message: string;
  linkText?: string;
  onClick?: () => void;
  fontWeight?: number;
}

/**
 * Empty state component for displaying when no data is available
 *
 * @param message - The main message to display
 * @param linkText - Optional clickable link text
 * @param onClick - Optional click handler for the link
 * @param fontWeight - Optional font weight for the message (defaults to 400)
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  linkText,
  onClick,
  fontWeight,
}) => (
  <div style={{ textAlign: 'center' }} data-testid='empty-state'>
    <img src={EmptyIcon} style={{ margin: '16px 0px', width: '100px' }} />
    <div
      style={{
        fontSize: 14,
        fontWeight: fontWeight ?? 400,
        marginTop: '10px',
      }}
    >
      {message}{' '}
      {linkText && (
        <span
          onClick={onClick}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          {linkText}
        </span>
      )}
    </div>
  </div>
);

export default EmptyState;
